import { ApiAttributeMapping, ApiPerson } from '../api';
import { Link } from 'react-router-dom';
import { getPersonDisplayName, isCounterparty } from './helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faUser } from '@fortawesome/pro-solid-svg-icons';
import { faUserAlien } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { InternalApiPerson, InternalApiPersonType } from '../api-internal';

interface PersonLinkProps {
  person: InternalApiPerson | ApiPerson;
  mappings: { [p: string]: ApiAttributeMapping };
}

export const PersonLink = ({ person, mappings }: PersonLinkProps) => {
  const getPersonName = (person: InternalApiPerson | ApiPerson) => {
    const personAttributes = person?.attributes;
    if (isCounterparty(person)) {
      return (
        personAttributes?.counterpartyName ||
        personAttributes?.name ||
        personAttributes?.counterpartyAccountNumber ||
        personAttributes?.account ||
        person.id
      );
    }
    if (!personAttributes) {
      return '';
    }
    return personAttributes.name || getPersonDisplayName(person, mappings);
  };

  return (
    <Link to={`/customer/${person.id}`}>
      {getPersonName(person)}
      {(person.type === InternalApiPersonType.BUSINESS || person.type === InternalApiPersonType.LEGAL) && (
        <span>
          {' '}
          <FontAwesomeIcon icon={faBriefcase} aria-label={person.type} />
        </span>
      )}
      {(person.type === InternalApiPersonType.INDIVIDUAL || person.type === InternalApiPersonType.PRIVATE) && (
        <span>
          {' '}
          <FontAwesomeIcon icon={faUser} aria-label={person.type} />
        </span>
      )}
      {isCounterparty(person) && (
        <span>
          {' '}
          <FontAwesomeIcon icon={faUserAlien} aria-label={person.category} />
        </span>
      )}
    </Link>
  );
};

export default PersonLink;
